exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mx-table-date .today {\n  border: 1px solid #1284e7;\n  color: #2a90e9;\n}\n.mx-datepicker {\n  min-width: 200px;\n  width: 100%;\n}\n", ""]);

// exports
